const LOCALE_MAP: Record<string, string> = {
    en: 'en_US',
    es: 'es_MX',
    fr: 'fr_FR',
};

/**
 * Returns the localized EarthRanger Help Center URL for the Gundi section.
 * @param language - The i18n language string (e.g. 'en', 'en-US', 'es', 'fr-FR')
 */
export const getHelpCenterUrl = (language: string): string => {
    const langCode = language?.split('-')[0];
    const locale = LOCALE_MAP[langCode] ?? 'en_US';
    return `https://support.earthranger.com/${locale}/gundi`;
};
